import { getSignedUrl } from '../services/api';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const openSignedUrl = async (key) => {
    if (!key) return;

    try {
        const res = await getSignedUrl(key);
        window.open(res.data.url, '_blank');
    } catch (error) {
        console.error('Failed to get signed URL:', error);
    }
};

export const fetchSignedUrl = async (key) => {
    if (!key) return null;

    try {
        const res = await getSignedUrl(key);
        return res.data.url;
    } catch (error) {
        console.error('Failed to get signed URL:', error);
        return null;
    }
};

// Proxy URL - streams file through backend (avoids signed URL expiry/CORS issues)
export const getProxyUrl = (key) => {
    if (!key) return null;
    const token = localStorage.getItem('token');
    return `${API_BASE_URL}/s3/proxy?key=${encodeURIComponent(key)}&token=${token}`;
};

// Redirect URL - public, generates fresh signed URL on each access
export const getRedirectUrl = (key) => {
    if (!key) return null;
    return `${API_BASE_URL}/s3/redirect?key=${encodeURIComponent(key)}`;
};
